var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elc-custom-referral-info"},[_c('div',{staticClass:"tip-message"},[_vm._v(_vm._s(_vm.$t('personal.referrals.rewards.custom.elc.tipMessage')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }